<template>
  <div>
    <h3 class="card__subheader">{{ title }}</h3>
    <div class="card card--xs card--noShadow fill--paper">
      <div class="card__content">
        <div class="grid grid--jcSpaceBetween" v-for="product in products" v-if="product.qty > 0">
          <p>{{ product.product_name }} x {{ product.qty }}</p>
          <p>£{{ (product.product_price * product.qty) | setDecimals }}</p>
        </div>
        <div class="grid grid--jcSpaceBetween text--bold">
          <p>Basket total</p>
          <p>£{{ (itemsTotal / 100) | setDecimals }}</p>
        </div>
      </div>
      <div class="card__content">
        <div v-for="adjustment in adjustments" class="grid grid--jcSpaceBetween">
          <p class="body">{{ adjustment.humanized_type }} <span v-if="adjustment.origin_code">({{ adjustment.origin_code }})</span></p>
          <p class="body">£{{ adjustment.amount / 100 | setDecimals }}</p>
        </div>
        <div class="grid grid--jcSpaceBetween text--bold">
          <p class="text--bold">Total</p>
          <p class="text--bold">£{{ (total / 100) | setDecimals }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props: ['title', 'order', 'products', 'price'],

    data() {
        return {
          adjustments: null,
          itemsTotal: 0,
          total: 0,
        }
    },

    beforeMount() {
      this.itemsTotal = this.$props.order.items_total;
      this.total = this.$props.order.total;

      this.adjustments = this.$props.order.adjustments;
    },
}
</script>
